<template>
  <div class="page_param">
    <div class="memberTop departMemberTop">
      <div class="memberInput">
        <ShowNavHead />
      </div>
    </div>
    <div class="f_crumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>系统</el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item>字段维护</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="param_tab_box">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="p_roster_table">
        <el-tab-pane label="字段维护" name="first"></el-tab-pane>
        <el-tab-pane label="花名册导入字段维护" name="second"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="system_setting">
      <div class="system_field">
        <p>客户行业维护</p>
        <button type="button" @click="setTree('JB_base_Custindust','行业')">设置</button>
      </div>
      <div class="system_field">
        <p>岗位类别信息维护</p>
        <button type="button" @click="setTree('JB_base_Jobcategory','岗位类别')">设置</button>
      </div>
      <div class="system_field">
        <p>业务类型维护</p>
        <button type="button" @click="paramSet('JB_base_Busitype','业务类型')">设置</button>
      </div>
      <!-- <div class="system_field">
        <p>招聘渠道维护</p>
        <button type="button" @click="paramSet('招聘渠道')">设置</button>
      </div> -->
      <div class="system_field">
        <p>岗位职能标签维护</p>
        <button type="button" @click="paramSet('JB_base_Jobfunclabel','岗位职能标签')">设置</button>
      </div>
      <div class="system_field">
        <p>客户/项目等级维护</p>
        <button type="button" @click="paramSet('JB_base_Custprolevel','客户/项目等级')">设置</button>
      </div>
      <div class="system_field">
        <p>社保类型维护</p>
        <button type="button" @click="paramSet('JB_base_Socialsec','社保类型')">设置</button>
      </div>
      <div class="system_field">
        <p>商保类型维护</p>
        <button type="button" @click="paramSet('JB_base_Busisec','商保类型')">设置</button>
      </div>
      <!-- <div class="system_field">
        <p>法务主体信息维护</p>
        <button type="button" @click="paramSet('JB_base_Legalsub','法务主体信息')">设置</button>
      </div> -->
    </div>
    <!-- 多级参数设置 -->
    <el-drawer :title="parmaName" :visible.sync="setTreeDrawer" direction="rtl" :size="430" :wrapperClosable="false">
      <div class="industryTree">
        <div class="treeSeach">
          <el-input placeholder="名称模糊查询" v-model="filterText"></el-input>
        </div>
        <el-tree ref="tree" :data="treeList" v-loading="treeLoading" element-loading-spinner="el-icon-loading" node-key="strParameterid" :filter-node-method="filterNode" :expand-on-click-node="false" @node-click="handleNodeClick">
          <span class="custom-tree-node" @mouseenter="mouseenter(data)" @mouseleave="mouseleave(data)" slot-scope="{ node, data }">
            <span v-if="!showEditIndustry || strParameterid!=data.strParameterid">
              <i class="el-icon-warning-outline" v-if="data.strIsDisable=='1'" style="color:#f56c6c;font-size: 16px;" title="已被禁用"></i>
              <span class="level_item">{{ data.strParametername }}</span>
              <span class="industryTree_btn" v-show="data.show">
                <el-button type="text" icon="el-icon-plus" v-if="node.level<2" @click.stop="() => append(node,data)" title="新增下级"></el-button>
                <el-button type="text" icon="el-icon-edit" @click="() => eidtIndustryName(node, data)" title="修改"> </el-button>
                <el-button type="text" :icon="data.strIsDisable == '1' ? 'el-icon-circle-check' : 'el-icon-circle-close'" @click.stop="() => banParam(data)" :title="data.strIsDisable == '1' ? '启用' : '禁用'"></el-button>
                <el-button type="text" v-if="!data.children" icon="el-icon-delete" title="删除" @click.stop="() => deleteTree(data)"> </el-button>
              </span>
            </span>
            <div v-if="showEditIndustry && strParameterid==data.strParameterid" class="editNewIndustry">
              <input v-model="paramInfo.parametername" type="text">
              <div class="editNewAgency industry_btn">
                <button type="button" class="agreeChange" @click="confirmEditIndustryName(node,data)">{{isadd ? '新增' : '确认修改'}}</button>
                <button type="button" class="cancelChange" v-if="!isadd" @click="showEditIndustry = false;strParameterid = ''">取消</button>
                <button type="button" class="cancelChange" v-if="isadd" @click="cancelAdd(node)">取消</button>
              </div>
            </div>
          </span>
        </el-tree>
      </div>
      <div v-if="!showAddIndustry" class="addLv cp">
        <i class="el-icon-plus" @click="showAddIndustry = true">新增一级{{parmaName}}</i>
      </div>
      <div v-if="showAddIndustry" class="addNewAgency">
        <input v-model="paramInfo.parametername" type="text">
        <div class="editNewAgency">
          <button type="button" class="agreeChange" @click="addFirstIndustry()">新增</button>
          <button type="button" class="cancelChange" @click="showAddIndustry = false">取消</button>
        </div>
      </div>
    </el-drawer>

    <el-drawer :title="parmaName + '设置'" :visible.sync="parmaDrawer" direction="rtl" :size="paramType=='JB_base_Legalsub' ? 1100 : 430" :wrapperClosable="false">
      <div v-if="paramType=='JB_base_Legalsub'">
        <div class="addLv cp">
          <i class="el-icon-plus" @click="addNewLeg">新增法务主体</i>
          <el-input v-model.trim="LegalsubData.keyword" placeholder="请输入法务主体名称" clearable @keyup.enter.native="getParameterList" style="width:300px;margin-left:430px"></el-input>
          <el-button type="success" plain size="small" @click="getParameterList" style="margin-left:10px">&nbsp;&nbsp;搜索&nbsp;&nbsp;</el-button>
          <el-button type="success" plain size="small" @click="exportLeg" :loading="btnLoading" style="margin-left:10px">&nbsp;&nbsp;导出&nbsp;&nbsp;</el-button>
        </div>
        <el-table :data="treeList" style="width: 100%" v-loading="tableLoading" element-loading-spinner="el-icon-loading">
          <el-table-column prop="StrLegalsubName" label="主体名称" width="300px">
            <template slot-scope="scope">
              <i class="el-icon-warning-outline" v-if="scope.row.strIsDisable=='1'" style="color:#f56c6c;font-size: 16px;" title="该主体已被禁用"></i>
              {{scope.row.StrLegalsubName}}
            </template>
          </el-table-column>
          <el-table-column prop="StrAccountName" label="会计姓名">
          </el-table-column>
          <el-table-column prop="StrCashierName" label="出纳姓名">
          </el-table-column>
          <el-table-column prop="StrLegalsubType" label="分类标签">
          </el-table-column>
          <el-table-column prop="StrSubordinat" label="从属主体">
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i class="el-icon-edit cp" style="color: #409EFF" @click="editLegalsubName(scope.row)" title="修改"></i>

              <i :class="scope.row.strIsDisable == '1' ? 'el-icon-circle-check cp' : 'el-icon-circle-close cp'" style="margin-left:10px;" @click="banParam(scope.row)" :title="scope.row.strIsDisable == '1' ? '启用' : '禁用'"></i>

              <i class="el-icon-delete cp" style="margin-left:10px; color: #f56c6c" title="删除" @click="deleteLeg(scope.row.Legalsubid)"></i>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination @current-change="changeBPage" :current-page.sync="LegalsubData.currpage" :page-size="LegalsubData.perpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" layout="total,sizes,prev,pager, next, jumper" :total="total"></el-pagination>
        </div>
      </div>
      <div v-else>
        <div v-for="item in treeList" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)" v-loading="treeLoading" element-loading-spinner="el-icon-loading" :key="item.strParameterid" class="level_item cp">
          <div v-if="!item.edit">
            <i class="el-icon-warning-outline" v-if="item.strIsDisable=='1'" style="color:#f56c6c;font-size: 16px;" title="已被禁用"></i>
            <span>{{ item.strParametername}}</span>
            <span v-show="item.show">
              <i class="el-icon-edit cp" style="margin-left:10px; color: #409eff;" @click="editName(item)" title="修改"></i>

              <i :class="item.strIsDisable == '1' ? 'el-icon-circle-check cp' : 'el-icon-circle-close cp'" style="margin-left:10px;" @click="banParam(item)" :title="item.strIsDisable == '1' ? '启用' : '禁用'"></i>

              <i class="el-icon-delete cp" style="margin-left:10px; color: #f56c6c;" @click="deleteTree(item)" title="删除"></i>
            </span>
          </div>
          <div v-else class="editInputContainer" @click.stop="">
            <input v-model="paramInfo.parametername" type="text" class="editInputName">
            <button type="button" class="agreeChange" @click="confirmEditLv(item,'edit')">确定修改</button>
            <button type="button" class="cancelChange" @click="cancelEditLv(item)">取消</button>
          </div>
        </div>
        <div v-if="!showAddLv" class="addLv cp">
          <i class="el-icon-plus" @click="addParma()">新增{{parmaName}}</i>
        </div>
        <div v-if="showAddLv" class="addNewAgency">
          <input v-model="paramInfo.parametername" type="text">
          <div class="editNewAgency">
            <button type="button" class="agreeChange" @click="confirmEditLv('','add')">新增</button>
            <button type="button" class="cancelChange" @click="showAddLv = false">取消</button>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-dialog :title="addLeg ? '新增法务主体' : '修改法务主体' " :visible.sync="dialogLegal" width="500px" :close-on-click-modal="false">
      <div class="paramform">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="主体名称" prop="strLegalsubName">
            <el-input v-model="ruleForm.strLegalsubName"></el-input>
          </el-form-item>
          <el-form-item label="会计姓名">
            <el-input v-model="ruleForm.strAccountName"></el-input>
          </el-form-item>
          <el-form-item label="出纳姓名">
            <el-input v-model="ruleForm.strCashierName"></el-input>
          </el-form-item>
          <el-form-item label="分类标签">
            <el-input v-model="ruleForm.strLegalsubType"></el-input>
          </el-form-item>
          <el-form-item label="从属主体">
            <el-input v-model="ruleForm.strSubordinat"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLegal = false">取 消</el-button>
        <el-button type="primary" @click="confirmLegal">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import xz from "@/common";
export default {
  data: function () {
    var validatname = (rule, value, callback) => {
      this.checkHandlename(res => {
        if (res) {
          callback()
        } else {
          callback(new Error('法务主体名称重复'));
        }
      })
    }
    return {
      treeLoading: false,
      tableLoading: false,
      btnLoading: false,
      //设置多级参数弹窗
      setTreeDrawer: false,
      parmaDrawer: false,
      //多级列表
      treeList: [],
      parmaList: [],
      nametest: [],
      showEditIndustry: false,
      //参数名称
      parmaName: '',
      //参数类型
      paramType: '',
      //树节点id
      strParameterid: '',
      showAddIndustry: '',
      isadd: '',
      showAddLv: false,
      filterText: '',
      paramInfo: {
        strtableid: '',
        parameterid: '',
        parametername: '',
        parametertopid: ''
      },
      dialogLegal: false,
      addLeg: true,
      ruleForm: {
        strtableid: 'JB_base_Legalsub',
        parameterid: '',
        strLegalsubName: '',
        strAccountName: '',
        strCashierName: '',
        strLegalsubType: '',
        strSubordinat: '',
        strIsDisable: ''
      },
      rules: {
        strLegalsubName: [
          { required: true, message: '请填写主体名称', trigger: 'blur' },
          { message: '法务主体名称重复', validator: validatname, trigger: ['blur'] }
        ]
      },
      LegalsubData: {
        currpage: 1,
        perpage: 10,
        keyword: '',
        strtableid: ''
      },
      total: 0,
      activeName:'first'
    };
  },
  created() {
    let roletype = localStorage.loginRoletype;
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    //切换tab
    handleClick(tab, event) {
      if(tab.name == 'second'){
        this.$router.push({
          path: '/employee-importField',
          query: {
            active:'second'
          }
        })
      }
    },
    setTree(type, name) {
      this.paramType = type;
      this.parmaName = name;
      this.getTreestr();
      this.setTreeDrawer = true;
    },
    //获取参数列表
    getTreestr() {
      let data = {
        currpage: 1,
        perpage: 100,
        strIsDisable: '',
        keyword: ''
      }
      this.treeList = [];
      this.treeLoading = true;
      xz.getTreestr(this.paramType, data).then(res => {
        if (res) {
          this.treeList = res.msg.parent;
        } else {
          this.treeList = [];
        }
        this.treeLoading = false;
      })
    },
    //树节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.strParametername.indexOf(value) !== -1;
    },
    handleNodeClick(node, data) {
      console.log(node, data)
    },
    //鼠标悬浮
    mouseenter(data) {
      this.$set(data, 'show', true)
    },
    mouseleave(data) {
      this.$set(data, 'show', false)
    },
    //新增下级
    append(node, data) {
      if (this.showEditIndustry) {
        return
      } else {
        this.strParameterid = '';
        this.$set(node, 'expanded', true)
        this.paramInfo = {
          strtableid: this.paramType,
          parameterid: '',
          parametername: '',
          parametertopid: data.strParameterid
        }
        const newChild = { strParameterid: this.strParameterid, strParametername: '' };
        if (!data.children || data.children == null) {
          this.$set(data, 'children', []);
        }
        data.children.push(newChild);
        this.showEditIndustry = true;
        this.isadd = true;
        console.log('add', node, data)
      }
    },
    //取消新增下级
    cancelAdd(node) {
      this.paramInfo.parametername = '';
      this.showEditIndustry = false;
      this.strParameterid = '';
      if (this.isadd) {
        node.parent.data.children.splice(node.parent.data.children.length - 1, 1);
        this.$set(node.parent.data, 'children', node.parent.data.children)
        this.isadd = false;
      }
    },
    //修改名称
    eidtIndustryName(node, data) {
      this.isadd = false;
      this.strParameterid = data.strParameterid;
      this.paramInfo = {
        strtableid: this.paramType,
        parameterid: data.strParameterid,
        parametername: data.strParametername,
        parametertopid: data.strTopParameterid
      }
      this.showEditIndustry = true;
      // this.parent = node.parent.data;
    },
    //确认
    confirmEditIndustryName() {
      if (this.paramInfo.parametername) {
        xz.saveJbParameter(this.paramInfo).then(res => {
          if (res.status == 'ok') {
            this.getTreestr();
            this.$message.success('保存成功');
            this.strParameterid = '';
          } else {
            this.$message.error('系统出错')
          }
        })
        this.showAddIndustry = false;
        this.showEditIndustry = false;
      } else {
        this.$message.warning('请填写名称')
      }
    },
    addFirstIndustry() {
      this.paramInfo = {
        strtableid: this.paramType,
        parameterid: '',
        parametername: this.paramInfo.parametername,
        parametertopid: ''
      }
      this.confirmEditIndustryName()
    },
    //删除参数
    deleteTree(data) {
      let info = {
        parameterid: data.strParameterid,
        strtableid: this.paramType
      }
      xz.delJbParameter(info).then(res => {
        if (res) {
          this.getTreestr();
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    //一级参数设置
    paramSet(type, name) {
      this.paramType = type;
      this.parmaName = name;
      type == 'JB_base_Legalsub' ? this.getParameterList() : this.getTreestr();
      this.parmaDrawer = true;
    },
    //修改参数名称
    editName(item) {
      this.paramInfo = {
        strtableid: this.paramType,
        parameterid: item.strParameterid,
        parametername: item.strParametername,
        parametertopid: ''
      }
      this.$set(item, 'edit', !item.edit);
    },
    confirmEditLv(item, type) {
      if (this.paramInfo.parametername) {
        xz.saveJbParameter(this.paramInfo).then(res => {
          if (res.status == 'ok') {
            this.getTreestr();
            this.$message.success('保存成功');
          } else {
            this.$message.error('系统出错')
          }
        })
        type == 'edit' ? this.$set(item, 'edit', !item.edit) : this.showAddLv = false;
      } else {
        this.$message.warning('请填写名称')
      }
    },
    //取消修改
    cancelEditLv(item) {
      this.$set(item, 'edit', !item.edit);
    },
    //新增参数
    addParma() {
      this.paramInfo = {
        strtableid: this.paramType,
        parameterid: '',
        parametername: '',
        parametertopid: ''
      }
      this.showAddLv = true;
    },
    //获取法务主体
    getParameterList() {
      this.LegalsubData.strtableid = this.paramType;
      xz.getParameterList(this.LegalsubData).then(res => {
        if (res) {
          this.treeList = res.msg;
          this.total = Number(res.totalcount);
        } else {
          this.treeList = [];
          this.total = 0;
        }
        this.tableLoading = false;
      })
    },
    //分页
    changeBPage(val) {
      this.LegalsubData.currpage = val;
      this.getParameterList();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.LegalsubData.perpage = '1';
      this.LegalsubData.perpage = val;
      this.getParameterList();
    },
    addNewLeg() {
      this.ruleForm = {
        strtableid: 'JB_base_Legalsub',
        parameterid: '',
        strLegalsubName: '',
        strAccountName: '',
        strCashierName: '',
        strLegalsubType: '',
        strSubordinat: ''
      }
      this.dialogLegal = true;
      this.addLeg = true;
    },
    editLegalsubName(item) {
      console.log(item)
      this.addLeg = false;
      this.ruleForm = {
        strtableid: 'JB_base_Legalsub',
        parameterid: item.Legalsubid,
        strLegalsubName: item.StrLegalsubName,
        strAccountName: item.StrAccountName_name,
        strCashierName: item.StrCashierName_name,
        strLegalsubType: item.StrLegalsubType,
        strSubordinat: item.StrSubordinat
      }
      this.dialogLegal = true;
    },
    confirmLegal() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          xz.saveJbParameter(this.ruleForm).then(res => {
            if (res.status == 'ok') {
              this.getParameterList();
              this.$message.success('保存成功');
              this.dialogLegal = false;
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //删除法务主体
    deleteLeg(id) {
      let info = {
        parameterid: 'JB_base_Legalsub',
        strtableid: id
      }
      xz.delJbParameter(info).then(res => {
        if (res) {
          this.getParameterList();
          this.$message.success('删除成功')
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    checkHandlename(callback) {
      let chkval = this.ruleForm.strLegalsubName;
      if (chkval.length > 0) {
        let data = {
          currpage: 1,
          perpage: 1000,
          keyword: chkval,
          strtableid: 'JB_base_Legalsub'
        }
        let a = 0;
        xz.getParameterList(data).then(res => {
          if (res.status == 'ok') {
            if (res.msg.length > 0) {
              let r = res.msg.some(ele => chkval === ele.StrLegalsubName)
              if (r) {
                callback(false)
              } else {
                callback(true)
              }
            } else {
              callback(true)
            }
          } else {
            callback(false)
          }
        })
      } else {
        callback(false)
      }
    },
    banParam(data) {
      let strIsDisable;
      data.strIsDisable == '1' ? strIsDisable = '0' : strIsDisable = '1';
      let info = {
        parameterid: data.strParameterid,
        strIsDisable: strIsDisable,
        strtableid: this.paramType
      }
      xz.disableJbParameter(info).then(res => {
        if (res.status == 'ok') {
          this.$message.success(res.msg);
          if (this.paramType == 'JB_base_Legalsub') {
            this.getParameterList();
          } else {
            this.getTreestr()
          }
        }
      })
    },
    exportLeg() {
      let data = {
        keyword: ''
      }
      xz.getOutUserLists('getOutLegalsubLists', data).then(res => {
        if (res.status == 'ok') {
          this.$router.push({
            path: "/sysexport",
            query: {
              showPage: 1,
              isActive: 1,
              radio2: '法务主体导出',
              custname: res.msg,
              //qStstus=1时查看最后一条导出记录
              qStstus: 1
            }
          })
        } else {
          this.$message({
            message: "导出失败，请稍后再试",
            type: "error"
          })
        }
        this.btnLoading = false;
      })
    }
  }
};
</script>
<style scoped>
.page_param .p_roster_table.el-tabs{
  background-color: #fff;
  box-sizing: border-box;
}
.page_param .param_tab_box{
  padding: 0 16px;
}
.f_crumbs{
  background-color: #f3f3f3;
  padding: 0px 15px ;
}
.page_param {
  background: #f3f3f3;
}
.system_setting {
  background: #fff;
  margin: 0 16px 30px;
  padding: 0 20px 20px;
}
.system_field {
  display: flex;
  padding: 15px 0;
  border-bottom: 1px solid #ddd;
}
.level_item {
  padding: 10px;
}
.level_item span {
  margin-right: 10px;
}
.editInputContainer {
  display: flex;
  align-items: center;
}

.editInputContainer button {
  border: none;
  font-size: 14px;
  outline: none;
  padding: 6px 16px;
  color: #fff;
  margin-right: 10px;
  border-radius: 3px;
}
.addLv {
  margin: 10px 0 20px 15px;
  font-size: 14px;
  color: #409eff;
}
.editInputName {
  width: 140px;
  height: 35px;
  border: 1px solid #ddd;
  border-radius: 3px;
  outline: none;
  margin-right: 20px;
  box-sizing: border-box;
  padding: 0 10px;
}

.addNewAgency {
  width: 250px;
  margin-bottom: 10px;
}
.addNewAgency input {
  border: 1px solid #ddd;
  border-radius: 5px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  height: 40px;
  outline: none;
}
.editNewAgency {
  margin: 8px auto 0 auto;
  justify-content: space-between;
  display: flex;
}
.editNewAgency button {
  display: block;
  font-size: 14px;
  outline: none;
  color: #fff;
  border: none;
  border-radius: 3px;
  padding: 8px 13px;
  margin-right: 10px;
}
.agreeChange {
  background: #409eff;
}
.cancelChange {
  background: #67c23a;
}

.system_field:last-child {
  border: none;
}
.system_field p {
  font-size: 14px;
  color: #333;
  width: 30%;
  line-height: 35px;
}
.system_field button {
  color: #67c23a;
  background: #f0f9eb;
  border-color: #c2e7b0;
  padding: 8px 16px;
}
.industry_btn {
  height: 32px;
  margin: 0 0 0 10px;
}
.editNewIndustry {
  line-height: 32px;
  height: 32px;
  display: flex;
}
.editNewIndustry input {
  margin-left: 15px;
  width: 130px;
  padding: 0 5px;
}
</style>
<style>
.page_param .el-breadcrumb{
  margin: 10px 0;
}
.page_param .el-drawer__header {
  font-size: 18px;
}
.page_param .el-drawer__body {
  padding-left: 30px;
  font-size: 14px;
}
.industryTree_btn i {
  font-size: 16px;
  margin-left: 5px;
}
.industryTree_btn i.el-icon-plus {
  color: rgb(237, 175, 84);
}
.industryTree_btn i.el-icon-edit {
  color: #409eff;
}
.industryTree_btn i.el-icon-delete {
  color: #f56c6c;
}
.industryTree_btn i.el-icon-circle-close {
  color: #f56c6c;
}
.industryTree_btn i.el-icon-circle-check {
  color: #67c23a;
}
.industryTree .el-tree-node__content {
  min-height: 32px;
}
.treeSeach .el-input__inner {
  width: 200px;
  margin: 0 0 10px 0px;
}
.industryTree .custom-tree-node {
  width: 340px;
}
.paramform .el-select {
  width: 100%;
}
.page_param i.el-icon-circle-close {
  color: #f56c6c;
}
.page_param i.el-icon-circle-check {
  color: #67c23a;
}
.addLv .el-input__inner {
  height: 36px;
  line-height: 36px;
}
.addLv .el-button--small,
.el-button--small.is-round {
  padding: 11px 15px;
}
</style>

